import { titleSortFilters } from "../../../Components/titleSortFilters"

// Sortable column headers for the Deflect breakdown tables.
//
// The platform hides antd's own sorter carets globally (App.less, `.ant-table-column-has-
// sorters .ant-table-column-sorter { display: none }`) and draws its own sort icon inside
// the header instead, through titleSortFilters, the way the Alerts and Health tables do. A
// column that only sets `sorter` therefore sorts on click but shows nothing at all, so
// every sortable column here builds its title with this helper: the label plus the icon
// for the current sort state.
//
// `key` must be the column's dataIndex: titleSortFilters matches the active sort by
// dataIndex to decide which header shows the ascending / descending icon.
export const sortableTitle =
  (title, key, { align } = {}) =>
  (state) =>
    titleSortFilters({
      title,
      sorter: true,
      stateData: state || {},
      key,
      justify: align === "right" ? "end" : "start"
    })
